import PaidInclusionConstants from 'app/shared/constants/PaidInclusionConstants';

const getDisplayPrice = (product) => {
    const {
        type,
        paymentValidDuration,
        price,
    } = product;

    const displayPrice = type === PaidInclusionConstants.PRODUCT_TYPE[1]
        ? `${price} per ${paymentValidDuration}`
        : `${price} for ${paymentValidDuration}`;

    return displayPrice;
};

export {
    getDisplayPrice,
};
